<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.CHANGE_PASSWORD'"> </span></div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.CHANGE_PASSWORD'"> </span></li>
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-xl-10">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0"><span [translate]="'GREATER.CHANGE_PASSWORD'"> </span></h5>
                            </div>
                            <hr>
                            <div class="custom-form">
                                <form [formGroup]="ResetData" class="row g-3">
                                    <div class="col-md-4">
                                        <div class="form-group pb-4">
                                            <label class="form-label m-0" for="Password"><span [translate]="'GREATER.OLD_PASSWORD'"> </span></label>
                                            <div class="input-with-ic">
                                                <input type="password" class="form-control" id="password-field"  placeholder="***********" minlength="8" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                                <span class="input-icon" (click)="showHide('.toggle-password')"> 
                                                    <i class="bx bx-low-vision toggle-password" toggle="#password-field"></i> 
                                                </span>
                                            </div>
                                            <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.password.errors">                                                     
                                                <div *ngIf="f['password'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                                <div *ngIf="f['password'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group pb-4">
                                            <label class="form-label m-0" for="Password"><span [translate]="'GREATER.NEW_PASSWORD'"> </span></label>
                                            <div class="input-with-ic">
                                                <input type="password" class="form-control" id="password-field1"  placeholder="***********" minlength="8" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="npassword" [ngClass]="{ 'is-invalid': submitted && f.npassword.errors }">
                                                <span class="input-icon" (click)="showHide('.toggle-password1')"> 
                                                        <i class="bx bx-low-vision toggle-password1" toggle="#password-field1"></i> 
                                                    </span>
                                            </div>
                                            <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.password.errors">                                                     
                                    <div *ngIf="f['npassword'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                    <div *ngIf="f['npassword'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                </small>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group pb-4">
                                            <label class="form-label m-0" for="ConfirmPassword"><span [translate]="'GREATER.CONFIRM_PASSWORD'"> </span></label>
                                            <div class="input-with-ic">
                                                <input type="password" class="form-control" id="password-field2"  placeholder="***********" minlength="8" onkeyup="this.value=this.value.replace(/^\s+/g, '')" formControlName="cpassword" [ngClass]="{ 'is-invalid': submitted && f.cpassword.errors }">
                                                <span class="input-icon" (click)="showHide('.toggle-password2')"> 
                                                <i class="bx bx-low-vision toggle-password2" toggle="#password-field2"></i> 
                                            </span>
                                            </div>
                                            <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.cpassword.errors"> 
                                                <div *ngIf="f['cpassword'].errors['required']"><span [translate]="'GREATER.PASSWORD_IS_REQUIRED'"> </span></div>
                                                <div *ngIf="f['cpassword'].errors['pattern']"><span [translate]="'GREATER.PASSWORD_LENGTH_CHECK'"> </span></div>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-btn-box pt-4 col-12 d-flex">
                                        <button type="click" class="btn custom-btn gradient1-btn px-5 me-5" (click)="service.back()"><span [translate]="'GREATER.BACK'"> </span>
                                        </button>
                                        <button type="submit" class="btn custom-btn gradient1-btn px-5" (click)="Onsubmit()"><span [translate]="'GREATER.UPDATE'"> </span></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>